import { useArea } from '../store/area.store'
import { useAvatarStore } from '../store/avatar.store'
import { useCart } from '../store/cart.store'
import { useCatalog } from '../store/catalog.store'
import { useDocuments } from '../store/documents.store'
import { useProduct } from '../store/product.store'
import { useService } from '../store/service.store'
import { useAuth } from '../store/auth.store'

/**
 * Clears every store that holds one customer's data.
 *
 * Called on both entering and leaving a customer. Skipping it means the next
 * customer inherits the previous one's chosen area — which silently produces
 * the wrong catalog, because choosedArea is a path parameter on
 * /client/products/{extId}/{area} — and their cart, which would let an agent
 * submit one customer's basket against another.
 *
 * Each store owns its own reset so the persist middleware writes the cleared
 * state through to localStorage automatically. Clearing localStorage from here
 * instead would leave the in-memory state stale until a reload.
 *
 * agent.store is deliberately untouched: it holds the agent's own identity and
 * token, which must survive every switch.
 */
export const resetCustomerScopedState = () => {
  useArea.getState().reset()
  useAvatarStore.getState().reset()
  useCart.getState().reset()
  useCatalog.getState().reset()
  useDocuments.getState().reset()
  useProduct.getState().reset()
  useService.getState().reset()
  useAuth.getState().setUser(null)
}
